'use client';

import { QRCodeSVG } from 'qrcode.react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { APP_STORE_URL, PLAY_STORE_URL } from '@/lib/app-store-urls';

interface DownloadModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function DownloadModal({ open, onOpenChange }: DownloadModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Téléchargez l'application Finsly</DialogTitle>
          <DialogDescription>
            Scannez le code QR avec votre téléphone pour télécharger l'application
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col items-center gap-6 py-4">
          <div className="flex flex-col sm:flex-row gap-6 items-center justify-center">
            {/* App Store QR Code */}
            <div className="flex flex-col items-center gap-3">
              <div className="p-4 bg-white rounded-lg border-2 border-gray-200">
                <QRCodeSVG
                  value={APP_STORE_URL}
                  size={160}
                  level="H"
                  includeMargin={false}
                />
              </div>
              <p className="text-sm font-medium text-gray-700">App Store</p>
              <a
                href={APP_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-[hsl(var(--primary))] hover:underline"
              >
                Ouvrir dans l'App Store
              </a>
            </div>

            {/* Google Play QR Code */}
            <div className="flex flex-col items-center gap-3">
              <div className="p-4 bg-white rounded-lg border-2 border-gray-200">
                <QRCodeSVG
                  value={PLAY_STORE_URL}
                  size={160}
                  level="H"
                  includeMargin={false}
                />
              </div>
              <p className="text-sm font-medium text-gray-700">Google Play</p>
              <a
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-[hsl(var(--primary))] hover:underline"
              >
                Ouvrir dans Google Play
              </a>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
